import { Pipe, PipeTransform } from '@angular/core';
import { PjesaLigjerates } from '@core/enums/pjesa-ligjerates.enum';
import { Constants } from '@core/globals/constants';
import { Baza } from '@core/interfaces/models/baza.interface';
import { Kerkimi } from '@core/interfaces/models/kerkimi.interface';

@Pipe({
  name: 'partOfSpeech',
})
export class PartOfSpeechPipe implements PipeTransform {
  transform(value: Kerkimi | Baza, type: 'short' | 'long' = 'short'): string {
    if (!value.pjesaLigjeratesId) {
      return '';
    }
    let pjesaLigjerates = '';
    pjesaLigjerates += Constants.PjesetLigjerates.find((p) => p.id == value.pjesaLigjeratesId)![type];

    const divider = type == 'long' ? ',' : '';

    if ('gjiniaId' in value || 'numriId' in value || 'llojiId' in value || 'kalimtaresiaId' in value) {
      switch (value.pjesaLigjeratesId) {
        case PjesaLigjerates.Emer:
          if (value.gjiniaId) pjesaLigjerates += divider + ' ' + Constants.EmriGjiniaVecoria.find((x) => x.id == value.gjiniaId)![type];
          break;
        case PjesaLigjerates.Mbiemer:
          if (value.gjiniaId) pjesaLigjerates += divider + ' ' + Constants.MbiemriGjinia.find((x) => x.id == value.gjiniaId)![type];
          if (value.llojiId) pjesaLigjerates += divider + ' ' + Constants.MbiemriLloji.find((x) => x.id == value.llojiId)![type];
          break;
        case PjesaLigjerates.Epapercaktuar:
          if (value.llojiId) pjesaLigjerates += divider + ' ' + Constants.EPapercaktuarLloji.find((x) => x.id == value.llojiId)![type];
      }
    }
    if ('emriBaza' in value || 'mbiemriBaza' in value || 'foljaBaza' in value || 'epapercaktuarBaza' in value) {
      switch (value.pjesaLigjeratesId) {
        case PjesaLigjerates.Emer:
          if (value.emriBaza?.gjiniaVecoriaId) pjesaLigjerates += divider + ' ' + Constants.EmriGjiniaVecoria.find((x) => x.id == value.emriBaza.gjiniaVecoriaId)![type];
          break;
        case PjesaLigjerates.Mbiemer:
          if (value.mbiemriBaza?.gjiniaId) pjesaLigjerates += divider + ' ' + Constants.MbiemriGjinia.find((x) => x.id == value.mbiemriBaza!.gjiniaId)![type];
          if (value.mbiemriBaza?.llojiId) pjesaLigjerates += divider + ' ' + Constants.MbiemriLloji.find((x) => x.id == value.mbiemriBaza!.llojiId)![type];
          break;
        // case PjesaLigjerates.Epapercaktuar:
        //   if (value.epapercaktuarBaza?.llojiId)
        //     pjesaLigjerates += divider + ' ' + Constants.EPapercaktuarLloji.find((x) => x.id == value.epapercaktuarBaza!.llojiId)![type];
      }
    }
    return pjesaLigjerates;
  }
}
